module.exports = __webpack_public_path__ + "static/media/bordertr.25e49d80.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/bordertr.png
// module id = 454
// module chunks = 0